import ActionsMenu from "../../../../components/action-buttons/ActionsMenu";
import React from "react";
import {Collapse, Empty, Skeleton, Spin} from "antd";
import {
  DownloadOutlined,
  FileTextOutlined,
  ShoppingCartOutlined
} from "@ant-design/icons";
import "./style.less";
import {useAuth} from "../../../../context/authContext";
import {TenderProcurementsTreeProps} from "../../types";
import {TenderProcurementsItem} from "../../../../types/tenderProcurements";

const {Panel} = Collapse;

const TenderProcurementsTree = (props: TenderProcurementsTreeProps) => {
  const {tenderProcurementsController} = props;
  const {
    tenderProcurementList,
    confirmDelete,
    downloadButtonHandler,
    editButtonHandler,
    isLoading
  } = tenderProcurementsController;
  const {canManageContent} = useAuth();

  const groupedByYear: Record<number, TenderProcurementsItem[]> = tenderProcurementList.reduce((acc, item) => {
    acc[item.year] = acc[item.year] || [];
    acc[item.year].push(item);
    return acc;
  }, {} as Record<number, TenderProcurementsItem[]>);

  const years = Object.entries(groupedByYear).sort(([firstYear], [secondYear]) => Number(secondYear) - Number(firstYear));

  if (isLoading && !tenderProcurementList.length) {
    return <section className="general-information-section">
      <div className="general-information-intro">
        <Skeleton active title={{width: 280}} paragraph={{rows: 2}}/>
      </div>
      <div className="general-information-loading">
        {Array.from({length: 4}).map((_, index) => <Skeleton active key={index} paragraph={{rows: 1}}/>)}
      </div>
    </section>;
  }

  return <Spin spinning={isLoading}>
    <section className="general-information-section">
      <div className="general-information-intro">
        <div className="general-information-intro__icon"><ShoppingCartOutlined/></div>
        <div>
          <div className="general-information-intro__eyebrow">Відкриті закупівлі</div>
          <h1 className="general-information-intro__title">Тендерні закупівлі</h1>
          <p className="general-information-intro__description">
            Документи та інформація щодо закупівель лікарні, впорядковані за роками.
          </p>
        </div>
      </div>

      {years.length ? <Collapse
        className="general-information-categories"
        defaultActiveKey={years.map(([year]) => year)}
        expandIconPosition="right"
      >
        {years.map(([year, items]) => <Panel
          header={<span className="general-information-category-title">
            <span>Закупівлі за {year} рік</span>
            <span className="general-information-category-count">{items.length}</span>
          </span>}
          key={year}
        >
          <div className="general-information-items">
            {items.map((item) => <article className="general-information-item"
                                          key={item.$id || `${year}-${item.title}`}>
              <button className="general-information-item__main" type="button"
                      onClick={() => downloadButtonHandler(item.fileId)}>
                <span className="general-information-item__icon"><FileTextOutlined/></span>
                <span className="general-information-item__content">
                  <span className="general-information-item__type">Документ закупівлі</span>
                  <span className="general-information-item__title">{item.title}</span>
                </span>
                <DownloadOutlined className="general-information-item__arrow"/>
              </button>

              {canManageContent && <div className="general-information-item__actions">
                <ActionsMenu onEdit={() => editButtonHandler(item)} onDelete={() => item.$id && confirmDelete({id: item.$id})}/>
              </div>}
            </article>)}
          </div>
        </Panel>)}
      </Collapse> : <div className="general-information-empty">
        <Empty description="Інформації про тендерні закупівлі поки немає"/>
      </div>}
    </section>
  </Spin>;
};

export default TenderProcurementsTree;
